$(document).ready(function(){
      $("#flip").click(function(){
        $("#panel").slideToggle("slow");
      });
    });


$(document).ready(function () {
        $("#delivery-schedule").click(function () {
            $("#deliver-order-now").prop("checked", false);
            $(".delivery-date-and-time").css("display", "block");
        });
		$("#delivery-order-now").click(function () {
            $("#schedule-delivery").prop("checked", false);
            $(".delivery-date-and-time").css("display", "none");
        });
    });


$(document).ready( function() {
    $(function() {
      $("#delivery-date").datepicker( {
        minDate: +0,
        maxDate: '+2M', 
      } );
    });
  });